import React from 'react'

import styled from '@emotion/styled'
import Image from '../../atoms/image';
import { mq, grayBorder } from '../../../_style';
import Sticky from 'react-sticky-el';

const Container = styled.div`
  padding-top: 180px;
  padding-bottom: 90px;
  border-bottom: 1px solid ${grayBorder};
  position: relative;
  ${mq.pc} {
    display: flex;
  }
  ${mq.sp} {
    padding-top: 110px;
  }
`
const ImgContainer = styled.div`
  ${mq.pc} {
    width: ${(960 - 450 - 60) / 960 * 100}%;
    margin-right: 60px;

    &.onlySp {
      display: none;
    }
  }
  ${mq.sp} {
    width: 100%;
    margin-bottom: 60px;

    &.onlyPc {
      display: none;
    }
  }

  .sticky {
    margin-top: 61px;
    margin-bottom: -61px;
  }
`
const Inner = styled.div`
  ${mq.pc} {
    width: ${450 / 960 * 100}%;
  }
`

export default class DetailMain extends React.Component {
  render() {
    return(
        <Container className="fixarea">
            <ImgContainer className="onlyPc">
              <Sticky topOffset={-61} bottomOffset={151} boundaryElement=".fixarea" style = {{position: 'relative'}} hideOnBoundaryHit={false}>
                <Image filename={this.props.imgPath}></Image>
              </Sticky>
            </ImgContainer>
            <ImgContainer className="onlySp">
              <Image filename={this.props.imgPath}></Image>
            </ImgContainer>
          <Inner>
            {this.props.children}
          </Inner>
        </Container>
    )
  }
}
